import React, { useMemo } from 'react';
import { buildChallengeDocument, buildMethodDocument } from './threeDSDocuments.js';

/**
 * The 3DS method step: an invisible frame that lets the bank fingerprint
 * the device. Nothing for the customer to see or do.
 */
export function PayMethodFrame({ methodForm }) {
  const doc = useMemo(() => buildMethodDocument(methodForm), [methodForm]);
  if (!doc) return null;
  return (
    <iframe
      title="Card check"
      className="pay-method-frame"
      aria-hidden="true"
      tabIndex={-1}
      srcDoc={doc.html}
      // Markup we could not rebuild ourselves gets no access to this origin.
      sandbox={doc.sandboxed ? 'allow-scripts allow-forms' : undefined}
      data-testid="pay-method-frame"
    />
  );
}

/**
 * The 3DS challenge: the bank's own verification screen. Sized by the
 * stylesheet — the full width of the card and most of a phone's height —
 * never by fixed pixels.
 */
export function PayChallengeFrame({ acsURL, cReq, threeDSSessionData }) {
  const html = useMemo(
    () => buildChallengeDocument({ acsURL, cReq, threeDSSessionData }),
    [acsURL, cReq, threeDSSessionData],
  );
  if (!html) return null;
  return (
    <iframe
      title="Card verification by your bank"
      className="pay-challenge-frame"
      srcDoc={html}
      data-testid="pay-challenge-frame"
    />
  );
}
